/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="page-content">
        <div class="col-md-4 p-0 overflow-y">
          <v-wait for="teklifler-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <div class="call-requests d-flex flex-column ">
              <div class="call-req px-3 py-3 d-flex flex-row" @click="doSelectCallRequest(callreq)" :class="{active : (selectedCallRequest != null && selectedCallRequest.ID == callreq.ID)}" v-for="(callreq, index) in callRequests" :key="'cr-' + callreq.ID">
                <div class="call-req-status mr-3">
                  <span class="call-req-status-badge" :class="parseCallReqStatusClass(callreq.Status)">{{parseCallReqStatus(callreq.Status)}}</span>
                </div>
                <div class="call-req-info d-flex flex-column">
                  <h6 class="customer-name mb-1 text-uppercase font-weight-bold">{{callreq.Name}}</h6>
                  <span class="customer-phone mb-2">{{callreq.GsmNo}}</span>
                  <small v-if="callreq.ATS_CustomerId" class="customer-details mb-2 text-small">Bu numara, bir müşteri kaydıyla eşleşiyor. Müşteri adı <u>{{callreq.CUSTOMER_TITLE}}</u>, kişi adı <u>{{callreq.CONTACT_NAME}}</u></small>
                  <small class="request-date text-muted">{{parseCallRequestDate(callreq.Created)}}</small>
                </div>
              </div>
            </div>
          </v-wait>
        </div>
        <div class="col-md-4">
          <div id="conversation-body-messages" class="chat">
            <div class="messages" id="chat-messages">
              <div class="vue-wait-class" v-if="$wait.waiting('mesajlar-loading')">
                <img src="static/loading.svg" />
                <p>Mesajlar yükleniyor...</p>
              </div>
              <div v-else class="row mb-4" :id="'message-row' + index" v-for="(message, index) in messages" :key="message.MESSAGE_ID">
                <div class="col-md-12">
                  <div class="bubble clearfix" v-bind:class="{'own text-right' : message.PERSONEL_ID == getPersonelId}">
                    <span class="my-0" v-bind:class="{'float-right' : message.PERSONEL_ID == getPersonelId}">{{message.MESSAGE_TEXT}}</span>
                    <small class="text-muted mt-1"
                      v-bind:class="{'float-right' : message.PERSONEL_ID == getPersonelId, 'float-left': message.PERSONEL_ID != getPersonelId}" >
                      {{message.MESSAGE_DATE}} - {{message.PERSONEL_NAME}}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-panel">
              <div class="input-group">
                <textarea class="form-control" :disabled="!canWriteMessage" placeholder="Notunuzu buraya yazın..." v-model="messageText"
                  aria-label="Notunuzu buraya yazın..." aria-describedby="button-addon2"></textarea>
                <div class="input-group-append">
                  <button class="btn btn-primary" :disabled="!canWriteMessage" @click="insertMesaj()" type="button" id="button-addon2">Mesaj Gönder</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-0">
          <div class="call-req px-3 py-3 mb-4 d-inline-flex align-items-start flex-column w-100">
            <span class="call-req-status-badge mb-2" :class="parseCallReqStatusClass(selectedCallRequest.Status)">{{parseCallReqStatus(selectedCallRequest.Status)}}</span>
            <h6 class="customer-name mb-1 text-uppercase font-weight-bold">{{selectedCallRequest.Name}}</h6>
            <span class="customer-phone mb-2">{{selectedCallRequest.GsmNo}}</span>
            <small v-if="selectedCallRequest.ATS_CustomerId" class="customer-details mb-2 text-small">Bu numara, bir müşteri kaydıyla eşleşiyor. Müşteri adı <u>{{selectedCallRequest.CUSTOMER_TITLE}}</u>, kişi adı <u>{{selectedCallRequest.CONTACT_NAME}}</u></small>
            <small class="request-date text-muted">{{parseCallRequestDate(selectedCallRequest.Created)}}</small>
          </div>
          <div class="form-group mx-3 my-0 d-inline-flex flex-column align-items-start">
            <label for="statusSelect">Arama Kaydı Durumu</label>
            <select class="form-control mb-2" id="statusSelect" v-model="callReqStatus">
              <option value="-1">Durum Seçiniz...</option>
              <option value="0">ARANACAK</option>
              <option value="1">ARANDI</option>
              <option value="2">TAMAMLANDI</option>
            </select>
            <small id="statusSelect" class="form-text text-muted mb-3">
              İlgili kişiyi aradıysanız ve bir dönüş bekliyorsanız, örneğin kişi düşünmek için süre istediyse ve ya daha sonra aramanızı istediyse; arama durumunu <b>ARANDI</b> olarak ayarlayınız.<br /><br />
              Eğer ilgili kişi herhangi bir sebepten tekrar aranmak istemiyorsa ya da kişiyle yaptığınız görüşmeler olumlu ya da olumsuz sonuçlandıysa lütfen arama durumunu <b>TAMAMLANDI</b> olarak ayarlayınız.
            </small>
            <button class="btn btn-primary" @click="updateCallRequest()">Arama Durumunu Güncelle</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'Teklifler',
  data () {
    return {
      messages: [],
      messageText: '',
      callRequests: [],
      selectedCallRequest: null,
      callReqStatus: -1,
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canWriteMessage : function() { return this.$store.getters.userCanWriteMessage },
    canReadMessage : function() { return this.$store.getters.userCanReadMessage },
  },
  methods: {
    getCallRequests() {
      this.$wait.start('aranmalar-loading');

      axios
      .get('/api/call-requests/')
      .then(response => {
        this.callRequests = response.data
        if(this.callRequests && this.callRequests.length > 0) {
          this.selectedCallRequest = this.callRequests[0];
          this.getMesajlar();
        }
        this.$wait.end('aranmalar-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('aranmalar-loading')
      })
    },
    getMesajlar() {
      this.$wait.start('mesajlar-loading');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.TalepId = this.selectedCallRequest.ID
      getJson.TalepType = false;

      axios
      .post('/api/bids/' + getJson.TalepId + '/mesajlar', getJson)
      .then(response => {
        this.messages = response.data
        this.$wait.end('mesajlar-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('mesajlar-loading')
      })
    },
    insertMesaj() {
      if(!this.messageText)
        return

      this.$wait.start('mesaj-insert');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.TalepId = this.selectedCallRequest.ID
      getJson.TalepType = false; // aranma talebi belirteci
      getJson.MessageText = this.messageText

      axios
      .post('/api/bids/' + getJson.TalepId + '/mesaj-ekle', getJson)
      .then(response => {
        this.$wait.end('mesaj-insert')
        this.messageText = ''
        this.getMesajlar()
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('mesaj-insert')
      })
    },
    updateCallRequest() {
      if(this.callReqStatus == -1 || this.callReqStatus == this.selectedCallRequest.Status)
        return;

      this.$wait.start('aranmalar-loading');
      const newCallReq = {
        ...this.selectedCallRequest,
        Status: parseInt(this.callReqStatus)
      };

      axios
      .put('/api/call-requests/' + newCallReq.ID, newCallReq)
      .then(response => {
        this.$wait.end('aranmalar-loading')
        this.selectedCallRequest = newCallReq
        this.getCallRequests()
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('aranmalar-loading')
      })
    },
    cropData(val, len) { 
      if(val == null || val == undefined)
        return null;

      if((val.length + 3) > len) return val.substring(0, len) + '...' 
      else return val
    },
    parseCallReqStatus(status) {
      if (status == 0)
        return "ARANACAK";
      else if (status == 1)
        return "ARANDI";
      else if (status == 2)
        return "TAMAMLANDI";
      else return "TANIMSIZ";
    },
    parseCallReqStatusClass(status) {
      if (status == 0)
        return "bg-danger";
      else if (status == 1)
        return "bg-warning";
      else if (status == 2)
        return "bg-secondary";
      else return "Tanımsız";
    },
    parseCallRequestDate(createdDate) {
      return moment(createdDate).fromNow() + " - " + moment(createdDate).format("DD MMMM YYYY HH:mm")
    },
    doSelectCallRequest(callreq) {
      if(this.selectedCallRequest && this.selectedCallRequest.ID != callreq.ID) {
        this.selectedCallRequest = callreq
        this.getMesajlar()
      }
    }
  },
  beforeMount() {
    moment.locale('tr')
  },
  mounted() {
    this.$wait.start('mesajlar-loading');
    this.getCallRequests()
  }
}

</script>

<style scoped>

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .page-content {
    width: 100%;
    height: calc(100vh - 80px);
    max-height: calc(100vh - 80px);
    overflow: hidden;

    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  .page-content > .row {
    height: 100% !important;
    max-height: 100% !important;
  }

  .page-content > * {
    padding: 1rem;
    border-right: 1px solid #F0F0F0;
    height: 100%;
    max-height: 100%;
  }

  .chat {
    height: 100%;
    max-height: 100%;

    flex: 5;
    display: flex;
    flex-direction: column;
  }

  .chat .messages {
    flex-grow: 1;
    margin-bottom: 10px;
    padding-right: 5px;
    width: 100%;
    height: auto;
    max-height: calc(100% - 62px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .chat .text-panel {

  }

  .call-req {
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
  }

  .call-req.active {
    background-color: #F7F9FC;
  }

  .call-req .customer-name {
    line-height: 1;
    margin-top: 4px;
  }

  .call-req-status {
    min-width: 100px !important;
    width: 100px;
  }

  .call-req-status-badge {
    display: inline-block;
    min-width: 100px !important;
    width: 100px !important;
    text-align: center;
    font-size: .625rem !important;
    font-weight: 700;
    padding: 5px 8px 4px 8px;

    border-radius: 4px;
    color: #FFF;
  }

</style>


// WEBPACK FOOTER //
// src/components/AranmaTalepleriPage.vue